/**
 * Protected Route Component
 * Redirects to login page if user is not authenticated
 */

import { Navigate, useLocation } from "react-router-dom";
import { isAuthenticated } from "@/feature/auth";

interface ProtectedRouteProps {
  readonly children: React.ReactNode;
}

export const ProtectedRoute = ({
  children,
}: ProtectedRouteProps): React.JSX.Element => {
  const location = useLocation();

  if (!isAuthenticated()) {
    // Redirect to login, preserving the intended destination
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

